<span class ='ml-2'>
  <i [ngClass]="class" [title]="title"></i>
</span>